import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGame1Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "e/icon/device/game_1_line",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M12 3C12.5523 3 13 3.44772 13 4V5H14.5C18.6421 5 22 8.35786 22 12.5C22 16.6421 18.6421 20 14.5 20H9.5C5.35786 20 2 16.6421 2 12.5C2 8.35786 5.35786 5 9.5 5H11V4C11 3.44772 11.4477 3 12 3ZM14.5 7H9.5C6.46243 7 4 9.46243 4 12.5C4 15.5376 6.46243 18 9.5 18H14.5C17.5376 18 20 15.5376 20 12.5C20 9.46243 17.5376 7 14.5 7ZM15.5 10C16.0128 10 16.4355 10.386 16.4933 10.8834L16.5 11V11.5H17C17.5523 11.5 18 11.9477 18 12.5C18 13.0128 17.614 13.4355 17.1166 13.4933L17 13.5H16.5V14C16.5 14.5523 16.0523 15 15.5 15C14.9872 15 14.5645 14.614 14.5067 14.1166L14.5 14V13.5H14C13.4477 13.5 13 13.0523 13 12.5C13 11.9872 13.386 11.5645 13.8834 11.5067L14 11.5H14.5V11C14.5 10.4477 14.9477 10 15.5 10ZM8.5 10C9.88071 10 11 11.1193 11 12.5C11 13.8807 9.88071 15 8.5 15C7.11929 15 6 13.8807 6 12.5C6 11.1193 7.11929 10 8.5 10ZM8.5 12C8.22386 12 8 12.2239 8 12.5C8 12.7761 8.22386 13 8.5 13C8.77614 13 9 12.7761 9 12.5C9 12.2239 8.77614 12 8.5 12Z"
		})
	})
});
export default SvgGame1Line;
